const correctableState = {
  blockDescription:
    "We couldn't confirm your address with the USPS. Please verify your address so we can save it to your profile. If the address you entered isn't correct, please edit it or choose the suggested address below.",
  blockTitle: "Please confirm your address",
  cancelText: "Back to edit address",
  confirmText: "Continue with selected address",
  enteredAddress: "You entered:",
  suggestedAddress: "Suggested alternative:"
};

const errorState = {
  blockDescription:
    "We couldn't confirm your address with the USPS, Please verify your address so we can save it to your profile. Best practice is to select your address by typing it in 'Street 1' field.",
  blockTitle: "Please review your address:",
  confirmText: "Back to edit address"
};

export default {
  correctableState,
  errorState,
  modalTitle: "Edit your address"
};
